/**
 * Elegir entre tema claro, oscuro o el del sistema.
 *
 * Tres opciones y no un interruptor de dos, porque "seguir al sistema" es lo
 * que la mayoria quiere sin saber que lo quiere: el equipo ya alterna entre
 * el dia y la noche, y la aplicacion deberia acompanarlo salvo que alguien
 * diga lo contrario.
 */

import { Monitor, Moon, Sun } from 'lucide-react'
import { useTema, type Tema } from '@/application/tema/tema.context'

const OPCIONES: ReadonlyArray<{ valor: Tema; icono: typeof Sun; titulo: string }> = [
  { valor: 'claro', icono: Sun, titulo: 'Tema claro' },
  { valor: 'oscuro', icono: Moon, titulo: 'Tema oscuro' },
  { valor: 'sistema', icono: Monitor, titulo: 'Seguir al sistema' },
]

export function InterruptorDeTema() {
  const { tema, cambiarTema } = useTema()

  return (
    <div
      className="flex items-center gap-0.5 rounded-lg bg-[var(--secondary)] p-0.5"
      role="group"
      aria-label="Tema de la interfaz"
    >
      {OPCIONES.map(({ valor, icono: Icono, titulo }) => (
        <button
          key={valor}
          type="button"
          onClick={() => cambiarTema(valor)}
          title={titulo}
          aria-label={titulo}
          aria-pressed={tema === valor}
          className={`rounded-md p-1.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] ${
            tema === valor
              ? 'bg-[var(--card)] text-[var(--foreground)] shadow-sm'
              : 'text-[var(--foreground-muted)] hover:text-[var(--foreground)]'
          }`}
        >
          <Icono className="h-4 w-4" />
        </button>
      ))}
    </div>
  )
}
